var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.651 3.723A6.766 6.766 0 0 0 10 3.188a6.786 6.786 0 0 0-4.817 1.995A6.798 6.798 0 0 0 3.188 10a6.786 6.786 0 0 0 1.995 4.817A6.798 6.798 0 0 0 10 16.812a6.787 6.787 0 0 0 4.817-1.995A6.798 6.798 0 0 0 16.812 10a6.787 6.787 0 0 0-1.995-4.817 6.798 6.798 0 0 0-2.166-1.46M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m9.847 2.722a.592.592 0 0 0 .84 0 .594.594 0 0 0 0-.84L10.593 9.79V5.34a.594.594 0 0 0-1.188 0v4.695c0 .157.063.308.174.42z",
    clipRule: "evenodd"
  })));
};
export default SvgClock;